export const QUICK_POST_V3_FORM_ID = "quick-post-v3-form";

export const QUICK_POST_V3_FOOTER_TOOLBAR_PORTAL_ID =
  "quick-post-v3-footer-toolbar";

export const QUICK_POST_V3_MOBILE_SPACE_SELECT_PORTAL_ID =
  "quick-post-v3-space-select-for-mobile";

export const QUICK_POST_V3_MODAL_EXIT_MS = 200;

export const SPACE_SELECT_DROPDOWN_MAX_WIDTH = 400;
export const SPACE_SELECT_DROPDOWN_MAX_HEIGHT = 480;

export const LEGACY_TIPTAP_MODAL_Z_INDEX = 1050;

export const HEADLESSUI_PORTAL_ROOT_Z_INDEX = 1061;

export const HEADLESSUI_PORTAL_ROOT_ID = "headlessui-portal-root";

export const QUICK_POST_V3_PORTAL_LAYERING_STYLE_ID =
  "quick-post-v3-portal-layering";

export const COMPASS_PORTAL_CONTAINER_ID = "compass-portal-container";
